import { format } from 'date-fns';
import styled from 'styled-components';

import DateRangeBadge from 'components/shared/DateRangeBadge';
import DesktopOnly from 'components/shared/responsiveness/DesktopOnly';
import MobileOnly from 'components/shared/responsiveness/MobileOnly';
import { END_DATE, START_DATE } from 'constants/filterKeysConstants';
import { useNetworkPerformanceStore } from 'stores/networkPerformanceStore';
import { BodySmallBold } from 'styles/typography';

import { PROVIDER_PERFORMANCE_EXPORT_PARAMS } from '../constants';
import NetworkPerformanceApiExport from '../NetworkPerformanceApiExport';

export default function ProviderPerformanceHeader() {
  const startDate = useNetworkPerformanceStore((state) => state.filters[START_DATE]) as Date;
  const endDate = useNetworkPerformanceStore((state) => state.filters[END_DATE]) as Date;

  return (
    <Header>
      <TitleGroup>
        <TitleColumn>
          <Title>Provider Performance Overview</Title>
          <MobileOnly>
            <Subtitle>
              {format(startDate, 'MM/dd/yyyy')} - {format(endDate, 'MM/dd/yyyy')}
            </Subtitle>
          </MobileOnly>
        </TitleColumn>
        <DesktopOnly>
          <DateRangeBadge startDate={startDate} endDate={endDate} />
        </DesktopOnly>
      </TitleGroup>
      <RightGroup>
        <NetworkPerformanceApiExport params={PROVIDER_PERFORMANCE_EXPORT_PARAMS} filename='post-discharge-overview' />
      </RightGroup>
    </Header>
  );
}

const Header = styled.div`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const TitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled(BodySmallBold)`
  color: ${({ theme }) => theme.colors.black};
`;

const Subtitle = styled.span`
  color: ${({ theme }) => theme.colors.black50};
  font-size: 10px;
  font-weight: normal;
`;

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
